// extracted by mini-css-extract-plugin
export default {"prompt":"prompt---EBl1u","hint":"hint---LpHNx","actions":"actions---z4ExB"};